// Vendor imports
const Cookies = require('js-cookie')
// Client lib imports
const { localStorage } = require('client/lib/storage')
// Client V2 common imports
const { showTooltip } = require('client-v2/common/containers/tooltips/actions')

// Tooltip action dispatchers

function showCollectionProfileSubscribeTooltip() {
  const key = 'collection-profile-subscribe'
  return function (dispatch, getState) {
    if (!isUserEligible() || isTooltipDismissed(key)) {
      return false
    }
    const { user, collection, router } = getState()
    // Only show the tooltip on collection-profile posts page
    if (router.action !== 'collection-profile.showPosts') {
      return false
    }
    // Don't show the tooltip for yourself or if you're already subscribed
    if (user.id === collection['user_id'] || collection.isFollowing) {
      return false
    }
    dispatch(showTooltip({
      key,
      title: 'Subscribe',
      body: 'You’ll see new posts from this collection in your recommendations.',
      onDismiss() { setTooltipDismissed(key) }
    }))
    return true
  }
}

function showUserProfileFollowTooltip() {
  const key = 'user-profile-follow'
  return function (dispatch, getState) {
    if (!isUserEligible() || isTooltipDismissed(key)) {
      return false
    }
    const { user, profileUser, router } = getState()
    // Only show the tooltip on user-profile pages
    if (!router.action.startsWith('user-profile.')) {
      return false
    }
    // Don't show the tooltip for yourself or if you're already following the user
    if (user.id === profileUser.id || profileUser.isFollowing) {
      return false
    }
    dispatch(showTooltip({
      key,
      title: 'Follow',
      body: 'You’ll see more of this person’s posts & collections if you follow them.',
      onDismiss() { setTooltipDismissed(key) }
    }))
    return true
  }
}

module.exports = {
  showCollectionProfileSubscribeTooltip,
  showUserProfileFollowTooltip
}

// Helper functions

function isUserEligible() {
  return !!Cookies.get('ftu_tooltips')
}

const dismissedKeys = new Set((() => {
  // Assign initial state from localStorage
  const valueStr = localStorage.getItem('ftu_tooltips')
  return Array.from(JSON.parse(valueStr || '[]'))
})())

function isTooltipDismissed(key) {
  return dismissedKeys.has(key)
}

function setTooltipDismissed(key) {
  dismissedKeys.add(key)
  const valueStr = JSON.stringify([...dismissedKeys])
  localStorage.setItem('ftu_tooltips', valueStr)
}
